/* facade-extras.js — desktop feel upgrades. Self-contained, safe to remove.
   FINAL ARCHITECTURE NOTE: SPA routing was removed for good. Three implementations each
   broke a business-critical vendor app (COD King checkout overlay freeze, Judge.me widget
   death on repeat swaps) — those apps require real page loads. Navigation is native; the
   View Transitions API in theme.css provides the cross-fade. Do not reintroduce a router
   unless every installed app officially supports SPA navigation.
   NOTE: the experimental SPA router was REMOVED (v42). Rewriting the document in place
   left the previous page's WebGL render loop and app timers running invisibly — every
   navigation stacked another full-screen shader (freezing, phone heat) and third-party
   apps were never designed to re-initialise into a rewritten document. Navigation is
   native again: the View Transitions API (@view-transition in theme.css) provides the
   seamless cross-fade on real page loads, where apps are guaranteed to work. */
(function () {
  'use strict';
  /* ── Lenis-style smooth inertia scroll (lerp .1 — the reference feel) ──
     Desktop only · skips the product page (it owns the wheel) · never captures
     the wheel over inner scrollers (cards, panels, cart, search) · reduced-motion off. */
  if (window.matchMedia('(max-width:720px)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('tpl-product')) return;
  var target = window.scrollY, current = window.scrollY, raf = 0, active = false;
  var svc = 0;   /* smoothed scroll velocity → --sv: deeper products trail more (scroll-depth drift) */
  function maxScroll() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }
  var lastTs = 0;
  function loop(ts) {
    if (!lastTs) lastTs = ts;
    var dt = Math.min(ts - lastTs, 50); lastTs = ts;
    var k = 1 - Math.pow(0.88, dt / 16.7);          /* time-corrected — same feel at 60Hz and 144Hz */
    var step = (target - current) * k;
    if (step > 110) step = 110; else if (step < -110) step = -110;   /* never outrun the rasterizer — blank-tile flashes */
    current += step;
    svc += (step * 0.85 - svc) * 0.16;
    document.documentElement.style.setProperty('--sv', Math.max(-22, Math.min(22, svc)).toFixed(1) + 'px');
    if (Math.abs(target - current) < 1) { current = target; active = false; lastTs = 0;
      svc = 0; document.documentElement.style.setProperty('--sv', '0px'); }
    window.scrollTo(0, Math.round(current));         /* integer px — no sub-pixel repaint churn */
    if (active) raf = requestAnimationFrame(loop);
  }
  window.addEventListener('wheel', function (e) {
    if (e.ctrlKey) return;                                    /* pinch-zoom */
    if (document.documentElement.classList.contains('cart-open')) return;
    if (e.target.closest('.content-card,.panel-scroll,.pdp-sheet-scroll,.sheet-scroll-in,.cart-items,.search-results,.acc-body,.sg-card,.nav-drop,.nav-inline')) return;
    if (maxScroll() === 0) return;                            /* nothing to scroll */
    e.preventDefault();
    var d = e.deltaY;
    if (e.deltaMode === 1) d *= 16;                           /* Firefox line mode */
    target = Math.max(0, Math.min(maxScroll(), target + d));
    if (!active) { active = true; current = window.scrollY; cancelAnimationFrame(raf); raf = requestAnimationFrame(loop); }
  }, { passive: false });
  window.addEventListener('scroll', function () { if (!active) target = window.scrollY; }, { passive: true });
})();

/* ── NAV FADE — makes native navigations FEEL seamless on every browser ──
   Browsers with cross-document View Transitions get the real cross-fade from theme.css
   (old page holds until the new one is ready) — we step aside there. Everyone else gets
   a quick fade-out before the browser navigates; the destination fades in via `pagein`.
   Real navigations only: nothing here can ever touch app behaviour. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  if (('onpagereveal' in window) && window.matchMedia('(min-width:721px)').matches) return;   /* desktop native cross-fade; phones ALWAYS use our own deterministic fade (iOS cross-doc VT unreliable even on iOS 26) */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    var href = a.getAttribute('href');
    if (!href || href[0] === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return;
    e.preventDefault();
    try {                                                        /* links home hand home's OWN colour across */
      if (u.pathname === '/') {
        var hs = sessionStorage.getItem('fxHomeSeed');
        if (hs) sessionStorage.setItem('fxRoom', hs); else sessionStorage.removeItem('fxRoom');
        sessionStorage.setItem('fxRoomLock', '1');
      }
    } catch (err2) {}
    document.body.classList.add('leaving');                     /* content-only fade — room/grain keep running */
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tm')) || 450;
    setTimeout(function () { location.href = a.href; }, Math.max(120, v * 0.4));
  }, true);
})();
